// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-content-block__headline{padding-bottom:0;padding-top:0}.czt-content-block__headline+*{padding-top:0}.czt-content-block--dark{background-color:#163f6e}.czt-content-block__side__image{position:relative;display:inline-block;width:100%}", ""]);
// Exports
module.exports = exports;
